import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

export default class NilaiAfekTable extends Component {
  constructor(props) {
    super(props);

    this._onDeleteList = this._onDeleteList.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
  }

  _onDeleteList() {
    const { onDeleteList, fieldName } = this.props;
  }

  _onFormChange(event) {
    const { onChange } = this.props;
    onChange(event);
  }

  render() {
    const {
      list, error, onChange,
      fieldName, plafond_name, onFormChange, form,
    } = this.props;


    return (
      <div className="daftar-ekskul__content">
        <div className="daftar-ekskul__header" />
        <div className="daftar-ekskul__body">
          <table className="daftar-ekskul__table">
            <thead>
              <tr>
                <th>No</th>
                <th>NIS</th>
                <th>Nama Siswa</th>
                <th>Displin</th>
                <th>Nilai Akhir</th>

              </tr>
            </thead>
            <tbody>
              {/* {
                          map(journal.details, (list, idx) => (
                            <tr key={`journal_detail_${idx}`}>
                              <td>{idx + 1}</td>
                              <td>{list.code_of_account}</td>
                              <td>{list.parameter_code.title}</td>
                              <td>{list.description}</td>
                              <td className="nominal">{commaFormatted(list.amount)}</td>
                            </tr>
                          ))
                        } */}
              <tr>
                <td>1</td>
                <td>aa</td>
                <td>122</td>
                <td />
                <td />
              </tr>

            </tbody>
            {/* <tfoot>
                          <tr>
                            <td colSpan="1" className="nominal">Catatan Wali Kelas</td>
                            <td colSpan="8" className="nominal"></td>
                          </tr>
                        </tfoot> */}
          </table>
        </div>
      </div>
    );
  }
}
NilaiAfekTable.propTypes = {
  onFormChange: PropTypes.func,
  form: PropTypes.object.isRequired,
};
NilaiAfekTable.defaultProps = {
  onFormChange: noop,
};
